// extracted by mini-css-extract-plugin
module.exports = {"mpnqb8w":"mpnqb8w"};